import type { SolicitudDetalle } from "@/lib/types";

/**
 * Predicados puros sobre el estado de la solicitud · evitan strings
 * mágicos esparcidos por la UI.
 *
 * `enFlujo` cubre los estados activos del flujo (Nivel1 y NivelN) MÁS
 * `ListoParaAutorizacion`: normalmente ese estado dura microsegundos (el
 * backend resuelve el flujo en la misma transacción del envío), pero si en
 * ese momento faltan datos generales la solicitud se congela ahí sin
 * `Flujo` — un estado de recuperación donde Mesa de Control aún debe ver la
 * acción "Dar de baja" (el backend ya la permite sin Flujo para este estado,
 * ver `DarDeBajaPorMesaDeControl`). También incluye `Autorizada` (+ los 3
 * estados vestigiales de contabilización, hoy inalcanzables como `Estado` ·
 * decisión P29): Mesa de Control puede dar de baja una solicitud ya
 * autorizada, incluso con póliza generada/depositada, así que el detalle
 * debe seguir mostrando `AccionesAutorizadorCard` (con SOLO la acción de dar
 * de baja) en ese caso — junto con `AutorizacionTerminadaCard`, no en su
 * lugar (ver `terminada` abajo).
 * `EnRevisionDocumental` (Gestión Documental · fase 3): Mesa de Control puede darla de baja
 * mientras se revisan sus documentos; autorizar/rechazar aún no aplican.
 * `terminada` cubre los dos estados finales del flujo de autorización
 * (no incluye contabilización · esa es otra etapa).
 */
export function enFlujoDeAutorizacion(estado: SolicitudDetalle["estado"]): boolean {
  return (
    estado === "ListoParaAutorizacion" ||
    estado === "EnRevisionDocumental" ||
    estado === "EnAutorizacionNivel1" ||
    estado === "EnAutorizacionNivelN" ||
    estado === "Autorizada" ||
    estado === "EnColaContabilizacion" ||
    estado === "PolizaGenerada" ||
    estado === "EnviadaAContabilizacion"
  );
}

export function autorizacionTerminada(estado: SolicitudDetalle["estado"]): boolean {
  return estado === "Autorizada" || estado === "DadaDeBajaPorAutorizador";
}
